import React from 'react';
import { Icon, Button } from 'hfs-common-ui';
import { Trans } from 'react-i18next';
import { InternationalizationNameSpace as Ns } from '~/constants/internationalization-namespace';
import { PortalModal } from '~/components/views/common/styled/Modal/Modal';
import * as S from './styled';

export interface Props {
  title: string | React.ReactNode;
  iconType?: string;
  iconColor?: string;
  message: string | React.ReactNode;
  dismissCallback: () => void;
  dismissButtonText?: string | React.ReactNode;
}

export const MobileInfoModal = ({
  iconColor,
  iconType,
  title,
  message,
  dismissCallback,
  dismissButtonText,
}: Props) => {
  return (
    <PortalModal
      isOpen={true}
      hideHeader={false}
      header={
        <S.ControlButtonCommandErrorTitleDiv>
          {iconType !== undefined && <Icon type={iconType} color={iconColor} />}
          <span>{title}</span>
        </S.ControlButtonCommandErrorTitleDiv>
      }
      enforcedCloseOnBackdropClick={true}
      onClose={dismissCallback}
      infoOrErrorOrWarning={true}
      showCloseIcon={true}
    >
      <S.ControlButtonCommandErrorBodyDiv>
        <span>{message}</span>
      </S.ControlButtonCommandErrorBodyDiv>
      <S.ControlButtonCommandErrorFooterDiv>
        <Button
          customStyle={{
            color: 'brandPrimary',
            backgroundColor: 'transparent',
          }}
          onClick={dismissCallback}
        >
          {dismissButtonText ?? <Trans i18nKey="ok_button" ns={Ns.Common} />}
        </Button>
      </S.ControlButtonCommandErrorFooterDiv>
    </PortalModal>
  );
};

export default MobileInfoModal;
